import { render, staticRenderFns } from "./EditEmmaWidgetForm.vue?vue&type=template&id=68f5ed57&"
import script from "./EditEmmaWidgetForm.vue?vue&type=script&lang=ts&"
export * from "./EditEmmaWidgetForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports